import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Container from '../../common/Container/Container';
import Button from '../../common/Button/Button';
import { useModal } from '../../../context/ModalContext';
import styles from './Header.module.css';

const NAV_LINKS = [
  { name: 'Solutions', path: '/#solutions' },
  { name: 'Portfolio', path: '/#portfolio' },
  { name: 'Process',   path: '/#process'   },
  { name: 'About',     path: '/#about'     },
];

const Header = () => {
  const { openModal } = useModal();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, path) => {
    if (path.includes('#')) {
      const [route, hash] = path.split('#');

      if (location.pathname === route || location.pathname === '/') {
        // Already on the home page, just scroll
        e.preventDefault();
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      // If not on home page, let the Link navigate normally
      // The Home component will handle the scroll
      setMobileMenuOpen(false);
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // Already on home page, clear hash and scroll to top
      window.history.replaceState(null, '', '/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Navigate to home page (Link will handle it)
      window.location.href = '/';
    }
  };

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <Container>
        <div className={styles.headerContent}>

          <Link to="/" className={styles.logo} onClick={handleLogoClick}>
            <img
              src="/images/logo/ICON%20BLUE.png"
              alt="Kilonova Technologies"
              className={styles.logoImage}
            />
          </Link>

          <nav className={styles.desktopNav}>
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={styles.navLink}
                onClick={(e) => handleNavClick(e, link.path)}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/lab"
              className={`${styles.labLink} ${location.pathname === '/lab' ? styles.labLinkActive : ''}`}
            >
              Lab
            </Link>
          </nav>

          <div className={styles.headerActions}>
            <Button variant="primary" size="sm" onClick={openModal}>Get Started</Button>
          </div>

          <button
            className={styles.mobileMenuBtn}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={styles.menuIcon}>
              {mobileMenuOpen ? '✕' : '☰'}
            </span>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className={styles.mobileMenu}>
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={styles.mobileNavLink}
                onClick={(e) => handleNavClick(e, link.path)}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/lab"
              className={styles.mobileLabLink}
              onClick={() => setMobileMenuOpen(false)}
            >
              Lab
            </Link>
            <Button variant="primary" size="md" fullWidth onClick={openModal}>Get Started</Button>
          </div>
        )}
      </Container>
    </header>
  );
};

export default Header;